<template>
  <div>
    <router-view @tabChange="tabChange" />
    <van-tabbar
      v-model="active"
      class="bottom-tab"
      active-color="#FF5500"
      inactive-color="#666666"
      :zIndex="200"
      safe-area-inset-bottom
    >
      <van-tabbar-item @click="toPage('home')" data-stat="tabbar_首页">
        <span>首页</span>
        <img
          slot="icon"
          slot-scope="props"
          :src="props.active ? home.active : home.normal"
        />
      </van-tabbar-item>
      <van-tabbar-item @click="toPage('category')" data-stat="tabbar_分类" v-if="$route.name != 'freshHome'">
        <span>分类</span>
        <img
          slot="icon"
          slot-scope="props"
          :src="props.active ? category.active : category.normal"
        />
      </van-tabbar-item>
      <van-tabbar-item
        icon="friends-o"
        data-stat="tabbar_购物车"
        :badge="cartNumber"
        @click="toPage('cart')"
      >
        <span>购物车</span>
        <img
          slot="icon"
          slot-scope="props"
          :src="props.active ? cart.active : cart.normal"
        />
      </van-tabbar-item>
      <van-tabbar-item
        icon="setting-o"
        data-stat="tabbar_个人中心"
        @click="toPage('me')"
      >
        <span>我的</span>
        <img
          slot="icon"
          slot-scope="props"
          :src="props.active ? manager.active : manager.normal"
        />
      </van-tabbar-item>
    </van-tabbar>
  </div>
</template>
<script>
import { mapGetters,mapActions } from "vuex";
import {types as Home} from '@/store/home'
const getters = mapGetters({
  getPioltCity: Home.IS_PIOLICity,
  cartNumber: Home.CART_NUMBER,
});
export default {
  data() {
    return {
      targetUrl: `https://h5.${this.$uleUrl()}/yxd/community/`,
      active: 0,
      home: {
        normal: require("../../assets/img/home.png"),
        active: require("../../assets/img/home-active.png"),
      },
      category: {
        normal: require("../../assets/img/category.png"),
        active: require("../../assets/img/category-active.png"),
      },
      cart: {
        normal: require("../../assets/img/cart.png"),
        active: require("../../assets/img/cart-active.png"),
      },
      manager: {
        normal: require("../../assets/img/manager.png"),
        active: require("../../assets/img/manager-active.png"),
      },
      client_type: "wap_ylxdsq",
    };
  },
  activated() {
    this.getActive();
  },
  computed:{
    ...getters
  },
  mounted() {
    this.client_type = this.$cookies.get("ul_sch") || this.$cookies.get("client_type");
    this.getActive();
  },
  watch: {
    "$route.path": function (newVal) {
      switch (newVal) {
        case "/category/categoryList":
          this.active = 1;
          break;
        case "/cart/cartList":
          this.active = 2;
          break;
        case "userCenter":
          this.active = 3;
          break;
        default:
          this.active = 0;
      }
    },
  },
  methods: {
    getActive() {
      let path = this.$route.name;
      switch (path) {
        case "categoryList":
          this.active = 1;
          break;
        case "cartList":
          this.active = 2;
          break;
        case "userCenter":
          this.active = 3;
          break;
        default:
          this.active = 0;
      }
    },
    toPage(router) {
      // 已登录
      // if (this.$cookies.get("mall_cookie") || this.$cookies.get("ul_utk")) {
        if (router === "home") {
          this.toNext("/");
        } else if (router === "me") {
          // setTimeout(() => {
          // 	window.location.href = `//m.${this.$uleUrl()}/muser/user/center?client_type=${this.client_type}&name=${this.$route.query.name}&latng=${this.$route.query.latng}&addr=${
          // 		this.$route.query.addr
          // 	}&city=${this.$route.query.city}&module=${this.$route.query.module}`;
          // }, 200);
          this.toNext("/me/userCenter");
        } else if (router === "cart") {
          if(this.getPioltCity){
            this.$router.push({
              path: "/cart/cartList",
              query: { name: this.$route.query.name, latng: this.$route.query.latng, addr: this.$route.query.addr, city: this.$route.query.city, module: this.$route.query.module,freshActType:'1' },
            });
          } else {
            this.toNext("/cart/cartList");
          }
        } else if (router === "category") {
          if(this.getPioltCity){
            this.$router.push({
              path: "/category/categoryList",
              query: { name: this.$route.query.name, latng: this.$route.query.latng, addr: this.$route.query.addr, city: this.$route.query.city, module: this.$route.query.module,freshActType:'1' },
            });
          } else {
            this.toNext("/category/categoryList");
          }
          
        }
      // }
      // 未登录
      // else {
      //   this.targetUrl = `${this.targetUrl}${this.$route.fullPath}`;
      //   this.$dialog
      //     .confirm({
      //       title: "提示",
      //       message: "请先登录",
      //     })
      //     .then(() => {
      //       if (this.$browser().miniprogram) {
      //         window.wx.miniProgram.navigateTo({
      //           url:
      //             "/pages/authorize?target=" +
      //             encodeURIComponent(this.targetUrl) +
      //             "&type=webView", //跳转非tabBar页面(目前就指非首页index)。参数以路径后面拼接即可
      //         });
      //       } else {
      //         window.location.href = `//m.${this.$uleUrl()}/muser/user/login?target=${encodeURIComponent(
      //           this.targetUrl
      //         )}`;
      //       }
      //     })
      //     .catch(() => {
      //       this.active = 0;
      //     });
      // }
    },
    tabChange(path) {
      switch (path) {
        case "categoryList":
          this.active = 1;
          break;
        case "cartList":
          this.active = 2;
          break;
        case "userCenter":
          this.active = 3;
          break;
        default:
          this.active = 0;
      }
    },
  },
};
</script>
<style lang="scss" scoped></style>
